import TextEditor from 'CMFW/input/TextEditor';
import { AudioPlayer } from 'CMFW/layout/AudioPlayer';
import { EditorRow } from 'components/common/styles';
import React, { useContext } from 'react';
import styled from 'styled-components';
import KeyContext from 'CMFW/context/KeyContext';
import ModuleContext from 'CMFW/context/ModuleContext';

const TargetDialect: React.FC = () => {
  const parentKey = useContext(KeyContext);
  const module = useContext(ModuleContext);
  const moduleItemValue = module.getItemUpdatedValue(parentKey);
  
  // Extract sentence ID and dialect ID for unique key
  const sentenceId = module.getItemId();
  const dialectId = moduleItemValue?.dialectId || 0;
  
  return (
    <Wrapper>
      <Container>
        <TextEditor
          keyName={'text'}
          clKeyName={'conceptLinkerConcepts'}
          config={{
            toolBarInline: [['Bold']],
          }}
          autoGrow
        />
        <AudioPlayerStyled key={`audio-${sentenceId}-${dialectId}`} />
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

const Container = styled(EditorRow)`
  flex-grow: 1;
`;

const AudioPlayerStyled = styled(AudioPlayer)`
  && {
    margin: 0 4px;
  }
`;

export default TargetDialect;
